import { createAction } from '@reduxjs/toolkit';
import { stateName } from './constants';
export const startPromosAfterItemUpload = createAction("".concat(stateName, "/startPromosAfterItemUpload"));
export const nextPromoAfterItemUpload = createAction("".concat(stateName, "/nextPromoAfterItemUpload"));